export enum AgentAssignmentFilter {
  Unassigned = 'unassigned',
  Assigned = 'assigned',
}


export const AgentAssignmentFilterLabels = {
  [AgentAssignmentFilter.Assigned]: 'Assigned',
  [AgentAssignmentFilter.Unassigned]: 'Unassigned',
};

export const AgentAssignmentFilterKey = 'agent_assignment';
